<template>
    <rkm-overlay>
        <template v-if="centroCusto.setor.tipoId === enums.setorTipo.ENFERMAGEM">
            <rkm-layout-body :title="title">
                <template v-slot:actions>
                    <rkm-button
                        @click="exit"
                        color="danger"
                    >
                        Sair
                    </rkm-button>

                    <rkm-button
                        v-if="isPreAtendimento"
                        @click="$refs.Form.printCarteiraVacinacao()"
                        color="info"
                    >
                        Imprimir carteirinha de vacinação
                    </rkm-button>

                    <rkm-button
                        v-if="isEnfermagem"
                        :disabled="disableSaveDraftButton"
                        @click="$refs.Form.save(true)"
                        color="info"
                    >
                        Salvar rascunho
                    </rkm-button>

                    <rkm-button
                        @click="$refs.Form.save()"
                        color="primary"
                    >
                        Salvar
                    </rkm-button>
                </template>

                <template v-slot:subtitle>
                    <div class="sub-title">
                        <template v-if="!!form">
                            <div>
                                <span v-if="!!form.paciente.nomeSocial">
                                    <strong class="sub-title-nome">{{form.paciente.nomeSocial}} (Nome social)</strong> {{form.paciente.nome}} |
                                </span>

                                <span v-else>
                                    <strong class="sub-title-nome">{{form.paciente.nome}}</strong> |
                                </span>

                                <span>{{form.paciente.sexoDescricao}}</span>
                            </div>

                            <div>
                                <template v-if="form.paciente.dataNascimento">
                                    <span>
                                        {{form.paciente.idade}} |
                                    </span>

                                    <span>
                                        Nasceu em {{form.paciente.dataNascimento}}
                                    </span>
                                </template>

                                <span>
                                    <strong>CPF</strong> {{form.paciente.cpf ? form.paciente.cpf : '-'}}
                                </span>

                                <span>
                                    <strong>CNS</strong> {{form.paciente.cns ? form.paciente.cns : '-'}}
                                </span>

                                <span>
                                    <strong>Nome da mãe</strong> {{form.paciente.nomeMae ? form.paciente.nomeMae : '-'}}
                                </span>

                                <span>
                                    <strong>Telefone</strong>&nbsp;

                                    <template v-if="form.paciente.telefoneNumero">
                                        <rkm-button
                                            @click="$refs.ModalPacienteTelefone.open(form.paciente)"
                                            class="sub-title-link"
                                            color="link"
                                            title="Atualizar telefone"
                                        >
                                            {{form.paciente.telefoneNumero}}
                                        </rkm-button>

                                        <template v-if="form.paciente.telefoneNumero.length === 15">
                                            (Autoriza SMS: {{form.paciente.telefoneAutorizaSms ? 'Sim' : 'Não'}})
                                        </template>
                                    </template>

                                    <template v-else>-</template>
                                </span>
                            </div>

                            <div v-if="!!form.usuario.nome">
                                <span>
                                    <strong>Profisional</strong> {{form.usuario.nome}}
                                </span>

                                <span>
                                    <strong>CBO</strong> {{form.usuario.ocupacaoCodigo}}
                                </span>

                                <span>
                                    <strong>Especialidade</strong> {{!!form.usuario.especialidadeNome ? form.usuario.especialidadeNome : '-'}}
                                </span>
                            </div>
                        </template>
                    </div>
                </template>

                <rkm-layout-content :no-card-style="isEnfermagem && form && !form.paciente.isIdoso">
                    <FormPreAtendimento
                        v-if="isPreAtendimento"
                        :fila-id="filaId"
                        @loaded="loaded"
                        @redirect="redirectToList"
                        @saved="saved"
                        ref="Form"
                    />

                    <FormEnfermagem
                        v-else-if="isEnfermagem"
                        :agendamento-id="agendamentoId"
                        :fila-id="filaId"
                        :ficha-avaliacao="fichaAvaliacao"
                        @loaded="loaded"
                        @saved="saved"
                        ref="Form"
                    />

                    <FormPosConsulta
                        v-else-if="isPosConsulta"
                        :fila-id="filaId"
                        @loaded="loaded"
                        @saved="saved"
                        ref="Form"
                    />
                </rkm-layout-content>
            </rkm-layout-body>

            <ModalPacienteTelefone ref="ModalPacienteTelefone" />
        </template>

        <template v-else>
            <rkm-layout-body :title="title">
                <rkm-alert color="warning">
                    É necessário estar logado com um setor do tipo <strong>ENFERMAGEM</strong> para poder utilizar a funcionalidade.
                </rkm-alert>
            </rkm-layout-body>
        </template>
    </rkm-overlay>
</template>

<script>
// Components.
import FormPreAtendimento from '@/components/ambulatorio/atendimento-enfermagem/components/pre-atendimento/Form'
import FormEnfermagem from '@/components/ambulatorio/atendimento-enfermagem/components/enfermagem/Form'
import FormPosConsulta from '@/components/ambulatorio/atendimento-enfermagem/components/pos-consulta/Form'
import ModalPacienteTelefone from '@/components/ambulatorio/components/paciente/telefone/Modal'

// Enums.
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'

// Mixins.
import {error, repository} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    components: {
        FormPreAtendimento,
        FormEnfermagem,
        FormPosConsulta,
        ModalPacienteTelefone,
    },
    computed: {
        ...mapGetters({centroCusto: 'getCentroCusto'}),
        title() {
            if (this.isPreAtendimento) {
                return 'Pré-atendimento'
            }
            else if (this.isEnfermagem) {
                return 'Atendimento de enfermagem'
            }
            else if (this.isPosConsulta) {
                return 'Pós-consulta'
            }

            return ''
        },
        isPreAtendimento() {
            return this.tipoAtendimento === 'pre-atendimento'
        },
        isEnfermagem() {
            return this.tipoAtendimento === 'enfermagem'
        },
        isPosConsulta() {
            return this.tipoAtendimento === 'pos-consulta'
        },
        disableSaveDraftButton() {
            return this.isEnfermagem && this.model && (this.model.soap.finalizacao.desfecho.finalizado === true || this.model.soap.finalizacao.desfecho.finalizado === 'encaminhar')
        },
        isRetroativo() {
            return this.filaId === 0
        }
    },
    created() {
        this.setShowExitFormConfirmation()

        this.repositories = {
            fila: this.getConectaSusRepository('ambulatorio.fila'),
        }
    },
    data: () => ({
        enums: {setorTipo},
        additionals: null,
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions([
            'setLoading',
            'setShowExitFormConfirmation',
            'unsetLoading',
            'unsetShowExitFormConfirmation',
        ]),
        redirectToList() {
            this.unsetShowExitFormConfirmation()
            this.$router.push('/ambulatorio/atendimento-enfermagem/index')
        },
        loaded(value) {
            this.additionals = value.additionals ?? null
            this.form = value.form
            this.model = value.model ?? null
        },
        saved() {
            this.redirectToList()
        },
        exit() {
            this.showExitConfirmation(async () => {
                if (this.isEnfermagem && (this.isRetroativo || this.additionals.isRascunho)) {
                    this.redirectToList()
                } else {
                    this.setLoading()

                    return this.repositories.fila.sendBack(this.filaId)
                        .then(() => this.redirectToList())
                        .finally(() => this.unsetLoading())
                }
            }, this.handleError)
        },
    },
    mixins: [error, repository],
    props: {
        tipoAtendimento: {type: String, required: true},
        filaId: {type: Number, required: true},
        agendamentoId: {type: Number},
        fichaAvaliacao: {type: Boolean, default: true},
    },
}
</script>

<style scoped>
.sub-title {
    color: #222;
    font-size: 14px;
    text-transform: none !important;
}
.sub-title-link {
    font-size: 14px;
    height: auto;
    margin-bottom: 3px;
    padding: 0;
    text-align: top;
    text-transform: none !important;
}
.sub-title-nome {
    font-size: 18px;
}
</style>